import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by 易督导"
      links={[
        {
          key: 'Sinovo',
          title: 'Sinovo',
          href: 'http://www.yidudao.cn',
          blankTarget: true,
        },
        {
          key: 'ydd-igra',
          title: <GithubOutlined />,
          href: 'https://igra.yidudao.cn',
          blankTarget: true,
        },
        {
          key: 'ydd',
          title: '易督导',
          href: 'https://web.yidudao.cn',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
